// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/system';
import { Dialog, DialogActions, Button, Typography, Radio, RadioGroup, FormControlLabel } from '@mui/material/';
import stylesDef from './styles';

export type ZipType = 'panorama' | 'poletagimage';

interface ComponentProps {
  showDialog: boolean;
  onConfirm: (zipType: ZipType) => void;
  onCancel: () => void;
}

export const ZipTypeDialog = ({ showDialog, onConfirm, onCancel }: ComponentProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const [selectedZipType, setSelectedZipType] = useState<ZipType>('panorama');

  // Reset to the default selection each time the dialog is opened
  useEffect(() => {
    if (showDialog) setSelectedZipType('panorama');
  }, [showDialog]);

  return (
    <Dialog open={showDialog} sx={styles.dialog}>
      <Box sx={styles.dialogBox}>
        <Box sx={styles.dialogTitle}>
          <Typography variant="h3">Select image type</Typography>
        </Box>
        <Typography>Choose the type of images in this ZIP file so we can process it correctly.</Typography>
        <RadioGroup
          value={selectedZipType}
          onChange={(e) => setSelectedZipType(e.target.value as ZipType)}
        >
          <FormControlLabel value="panorama" control={<Radio color="primary" />} label="Panoramic Images" />
          <FormControlLabel value="poletagimage" control={<Radio color="primary" />} label="Pole images" />
        </RadioGroup>
        <DialogActions sx={styles.dialogActions}>
          <Button onClick={() => onConfirm(selectedZipType)} sx={styles.closeButton}>Continue</Button>
          <Button onClick={onCancel} sx={styles.cancelButton}>Cancel</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ZipTypeDialog;
